import cx from 'clsx';

import { MembershipDiscountNoticeTooltip } from '~/domains/plusMembership/components/Tooltips';
import type { OAISchema } from '~/types/openapi';
import { isMoreThan } from '~/utils/number';

type Props = {
  data: OAISchema['MarketProductDetailsResponseV2'];
};

export function DefaultProductPrice({ data }: Props) {
  const { price, priceBeforeDiscount, totalDiscountedPrice, discountResult } =
    data;

  const discountAmount = discountResult?.maximumDiscountAmount;

  return (
    <div>
      <div className="flex items-center">
        <span
          className={cx(
            'typo-heading200',
            Boolean(discountAmount) && discountAmount > 0 && 'text-hint',
          )}
        >
          {price ? `${price.toLocaleString()}원` : '상담신청 상품'}
        </span>
        {isMoreThan(priceBeforeDiscount, price) && (
          <span className="ml-4 text-hint line-through typo-paragraph100-regular">
            {priceBeforeDiscount.toLocaleString()}원
          </span>
        )}
      </div>
      {Boolean(discountAmount) && (
        <div className="relative">
          <div className="flex items-center gap-4 text-membershipBlue-text typo-heading200">
            <p>{totalDiscountedPrice?.toLocaleString()}원</p>
            <span className="typo-paragraph200-semibold">나의할인가</span>
            <MembershipDiscountNoticeTooltip />
          </div>
        </div>
      )}
    </div>
  );
}
